// frontend/src/hooks/useProspectCspe.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

/**
 * Fetch la liste paginée des prospects CSPE (accounts éligibles sans contrat signé).
 * Retourne { data, loading, error, refetch, page, setPage, pageSize, totalCount, totalPages }.
 * Nécessite session Supabase avec access_token.
 */
export function useProspectCspe(session, initialPageSize = 50) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(initialPageSize);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = useCallback(async () => {
    if (!session?.access_token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const resp = await axios.get('/api/admin/prospect-cspe', {
        params: { page, pageSize },
        headers: { Authorization: `Bearer ${session.access_token}` },
      });
      if (resp.data?.success) {
        setData(resp.data.data || []);
        setTotalCount(resp.data.totalCount ?? 0);
        setTotalPages(resp.data.totalPages ?? 1);
      } else {
        setError(resp.data?.error || 'Erreur inconnue');
      }
    } catch (e) {
      console.error('[useProspectCspe]', e);
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  }, [session?.access_token, page, pageSize]);

  useEffect(() => { fetchData(); }, [fetchData]);

  return { data, loading, error, refetch: fetchData, page, setPage, pageSize, totalCount, totalPages };
}
